import { FC, memo } from "react"
import { Container } from "@/styles/utils/StyledGrid"
import { Section } from "@/styles/utils/Utils"
import { Typography } from "@/ui/Typography/Typography"
import { StyledContent } from "./StyledCategoryDescription"

const CategoryDescription: FC<{
  text: string
}> = memo(({ text }) => {
  return (
    <Section>
      <Container>
        <Typography variant={"h2"}>
          <b>Описание</b>
        </Typography>
        <StyledContent
          dangerouslySetInnerHTML={{
            __html: `${text}`,
          }}
        />
      </Container>
    </Section>
  )
})

CategoryDescription.displayName = "CategoryDescription"

export { CategoryDescription }
